import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';
import { buildHotelBookingsQuery as buildResortBookingsQuery } from 'reducer/hotel';

export { buildResortBookingsQuery };

export const getResort = createAsyncThunk('GET RESORTS', async (data, thunkAPI) => {
  const query = buildResortBookingsQuery(data);
  const response = await AxiosAdmin.get(`${URL.RESORT_BOOKINGS}?${query}`, thunkAPI);
  return response.data;
});

export const getResortDetails = createAsyncThunk('GET RESORTS DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(`${URL.HOTEL_BOOKING_DETAILS_V2}/${data.referenceNumber}`, thunkAPI);
  return response.data;
});

export const updateResortRemarks = createAsyncThunk('UPDATE_RESORT_REMARKS', async (data, thunkAPI) => {
  const bookingId = data.booking_id ?? data.id ?? data.referenceNumber;
  const requestData = {
    remark_id: data?.remark_id || '',
    remark: data?.remark,
  };
  const response = await AxiosAdmin.patch(`${URL.RESORT_UPDATE}/${bookingId}`, requestData, thunkAPI);
  return response.data;
});

export const updateResortBooking = createAsyncThunk('UPDATE_RESORT_BOOKING', async (data, thunkAPI) => {
  const bookingId = data.booking_id ?? data.id ?? data.referenceNumber;
  const { booking_id, id, referenceNumber, ...payload } = data;
  const response = await AxiosAdmin.patch(`${URL.RESORT_UPDATE}/${bookingId}`, payload, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  resortData: null,
  resortDetails: null,
};

export const resortSlice = createSlice({
  name: 'resort',
  initialState,
  reducers: {},
  extraReducers: {
    [getResort.pending]: (state) => {
      state.isLoading = true;
    },
    [getResort.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.resortData = action.payload.data;
    },
    [getResort.rejected]: (state, action) => {
      state.isLoading = false;
      state.resortData = null;
      toast.error(action?.payload?.message);
    },
    [getResortDetails.pending]: (state) => {
      state.isLoading = true;
      state.resortDetails = null;
    },
    [getResortDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      const details = action.payload?.data;
      state.resortDetails = details?.bookings?.[0] || details;
    },
    [updateResortRemarks.pending]: (state) => {
      state.isLoading = true;
    },
    [updateResortRemarks.fulfilled]: (state) => {
      state.isLoading = false;
      toast.success('Remarks updated successfully');
    },
    [updateResortRemarks.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating remarks');
    },
    [getResortDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.resortDetails = null;
      toast.error(action?.payload?.message);
    },
    [updateResortBooking.pending]: (state) => {
      state.isLoading = true;
    },
    [updateResortBooking.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateResortBooking.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating cogs data');
    },
  },
});

export default resortSlice.reducer;
